<template>
  <div>
      <section class="experience py-5" id="experience">
            <div class="container py-3">
                <p class="paragraph">experiencia de trabalho</p>
                <h3 class="heading mb-sm-5 mb-4">Minha experiencia</h3>
                <div class="middile-inner-con">
                    <div class="tab-main mx-auto">

                        <input id="tab1" type="radio" name="tabs" checked>
                        <label for="tab1"><img src="https://avatars1.githubusercontent.com/u/45927983?s=460&v=4" alt="" class="img-fluid" /> Dataset Lda.</label>

                        <input id="tab2" type="radio" name="tabs">
                        <label for="tab2"><img src="../../static/images/aplic0.jpg" alt="" class="img-fluid" /> Aplic Consultória</label>

                        <input id="tab3" type="radio" name="tabs">
                        <label for="tab3"><img src="https://www.explicador.co.mz/images/explicador%20logo.png" alt="" class="img-fluid" /> Explicador Inc, LDA</label>

                        <section id="content1">
                            <div class="menu-grids">
                                <div class="t-in">
                                    <div class="text-info-sec">
                                        <div class="service-in text-left">
                                            <div class="card" >
                                                <div class="card-body p-0">
                                                <img src="../../static/images/s1.png" alt="" class="img-fluid"/>
                                                <img src="../../static/images/s2.png" alt="" class="img-fluid"/>
                                                <img src="../../static/images/s3.png" alt="" class="img-fluid"/>
                                                    <h3 class="mb-md-4">DataSet lda.</h3>
                                                    <h5 class="my-3 card-title" data-aos="fade-left">Web Developer at DataSet Lda. (10/2018 to 02/2019)</h5>
                                                    <p class="card-text" data-aos="fade-left">Está foi a primeira Empresa que Eu desenvolvi as técnicas de programação, Onde fiz o meu Prmeiro estagio de fim do curso.<br> Nesta Empresa aprendi a desenvolver sistemas web usando a linguagem JAVA (MAVEN). trabalhei tambem como suport técnico. </p>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="card" >
                                                <div class="card-body p-0">
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section id="content2">
                            <div class="menu-grids">
                                <div class="t-in">
                                    <div class="text-info-sec">
                                        <div class="service-in text-left">
                                            <div class="card">
                                                <div class="card-body p-0">
                                                <img src="../../static/images/s2.png" alt="" class="img-fluid" />
                                                <img src="../../static/images/s3.png" alt="" class="img-fluid" />
                                                <img src="../../static/images/s4.png" alt="" class="img-fluid" />
                                                    <h3 class="mb-md-4">Aplic Consultória</h3>
                                                    <h5 class="my-3 card-title" data-aos="fade-left">Developer at Aplic Consultória (06/2019 to 09/2019)</h5>
                                                    <p class="card-text" data-aos="fade-left">Nesta Empresa desenvolvi aplicações com C# para Todas as Plataformas(Mobile, Desktop, Web).</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section id="content3">
                            <div class="menu-grids">
                                <div class="t-in">
                                    <div class="text-info-sec">
                                        <div class="service-in text-left">
                                            <div class="card">
                                                <div class="card-body p-0">
                                                    <img src="../../static/images/s4.png" alt="" class="img-fluid" />
                                                    <img src="../../static/images/s5.png" alt="" class="img-fluid" />
                                                    <img src="../../static/images/s6.png" alt="" class="img-fluid" />
                                                    <h3 class="mb-md-4">Explicador Inc, LDA.</h3>
                                                    <h5 class="my-3 card-title">Working as a Developer at Explicador (Now)</h5>
                                                    <p class="card-text">trabalhando nesta Empresa desde ja pra frente.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
export default {
  name: 'Experience',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Experience.vue